import {EndSection} from '..';
import {Typography} from '@material-ui/core';
import {AutoField} from '../fields';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
import sanitizeData from 'components/forms/sections/Review/sanitizer';

const sanitizer = data => {
    const profileData = sanitizeData(data);
    if (profileData.applicant_MMC === '' || profileData.applicant_MMC === 0) {
        profileData.applicant_MMC = null;
    }
    return profileData;
};

const NationalDriverRegistryConsent = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldDict
    );

    return (
        <EndSection
            {...props}
            schema={schema}
            initialValues={initialValues}
            endpointOverride='profile'
            method='put'
            sanitizeFunction={sanitizer}
        >
            <Typography variant='h6' align='left'>
                {sectionName}
            </Typography>
            <AutoField
                field={fieldDict['ndr_to_uscg_authorization']}
                name='ndr_to_uscg_authorization'
            />
        </EndSection>
    );
};

export default NationalDriverRegistryConsent;
